export default __webpack_public_path__ + "static/satelliteright-044d4e0a15a561ac90977346585bd585.png";